export type LgdParsedTime = Readonly<[number, number, number]> | null;

export function isLgdParsedTime(o: unknown): o is LgdParsedTime
{
    return !!o && Array.isArray(o) && o.length === 3 && o.reduce((r, x) => r && typeof x === "number", true);
}

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/time#time_value_format
 */
const timeFormatPattern = /([0-2]\d):([0-5]\d):?([0-5]\d)?/;

/**
 * Attempts to convert a string that should conform the the time value format defined by th e`input[time]` html spec to
 * a 3-tuple of numbers, representing `[ hours, minutes, seconds ]`.
 *
 * @param value string 24-hour format that includes leading zeros.
 * @returns parsedTime `null` for invalid inputs, a 3-tuple contains hours, minutes, and seconds.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/time#time_value_format
 */
export function parseLgdParsedTime(value?: string): LgdParsedTime
{
    if (value === undefined || value === null)
    {
        return null;
    }

    const match = timeFormatPattern.exec(value);
    if (!match)
    {
        return null;
    }

    const hours = parseInt(match[1]);
    const minutes = parseInt(match[2]);
    const seconds = match.length === 4 && !!match[3] ? parseInt(match[3]) : 0;
    return [hours, minutes, seconds];
}

export function compareTimes(o1: LgdParsedTime, o2: LgdParsedTime): number
{
    if (!o1 && !o2) return 0;

    if (!o1 && !!o2) return -1;

    if (!!o1 && !o2) return 1;

    let index = 0;
    while (index < o1.length)
    {
        if (o1[index] === o2[index])
        {
            index++;
            continue;
        }

        // simplifying result to ease testing.....
        return o1[index] - o2[index] > 0 ? 1 : -1;
    }

    return 0;
}
